import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom"; // Import de useLocation
import { Menu, ShoppingBag, X } from "lucide-react";
import { CartContext } from "../contexts/CartContext.js";
import "../styles/Menu.css";

export default function TopMenu() {
  const { cartItems } = useContext(CartContext);
  const cartCount = cartItems.length;
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation(); // Récupération de la localisation actuelle

  // Si le path commence par "/cart", on masque l'icône du panier
  const hideCartIcon = location.pathname.startsWith("/checkout") || !cartCount;

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="mobile-menu">
      <Link to="/" className="logo-container" onClick={closeMenu}>
        <img src="/assets/logos/logo-balteemobility-black.png" alt="Logo" className="logo-image" />
      </Link>


      <nav className="desktop-menu-show desktop-menu">
        <ul>
          <li><Link to="/" onClick={closeMenu}>Accueil</Link></li>
          <li><Link to="/product/boitier-multifonction-securite-velo-trottinette-b01" onClick={closeMenu}>B01</Link></li>
          <li><Link to="/product/boitier-multifonction-securite-velo-trottinette-b01-lite/BLACK" onClick={closeMenu}>B01 Lite</Link></li>
          <li><Link to="/product/casque-intelligent-lumineux-h01" onClick={closeMenu}>H01</Link></li>
          <li><Link to="https://billing.stripe.com/p/login/5kA2aC7yh6qA2mQfYY" target="_blank" onClick={closeMenu}>Mon compte</Link></li>
          <li><Link to="/l-histoire-de-baltee-mobility" onClick={closeMenu}>L'histoire</Link></li>
          <li><Link to="/foire-aux-questions" onClick={closeMenu}>F.A.Q</Link></li>
          <li><Link to="/qr/notices-utilisation" onClick={closeMenu}>Notices</Link></li>
          <li><Link to="/contact" onClick={closeMenu}>Contact & SAV</Link></li>
          <li><Link to="/articles" onClick={closeMenu}>Articles</Link></li>
        </ul>
      </nav>

      <div className="icons">
        {/* Affichage conditionnel de l'icône panier */}
        {!hideCartIcon && (
          <Link to="/checkout/cart" className="cart-container" onClick={closeMenu}>
            <ShoppingBag className="icon" />
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </Link>
        )}

        {/* Icône Menu avec gestion de l'affichage */}
        <div className="menu-icon mobile-menu-show" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X className="icon" /> : <Menu className="icon" />}
        </div>
      </div>

      {/* Menu déroulant */}
      {menuOpen && (
        <nav className="dropdown-menu mobile-menu-show">
          <ul>
            <li className="border-bottom">
              <Link to="/" onClick={closeMenu}>Accueil</Link>
            </li>
            <li>
              <Link to="/product/boitier-multifonction-securite-velo-trottinette-b01" onClick={closeMenu}>B01</Link>
            </li>
            <li className="border-bottom">
              <Link to="/product/boitier-multifonction-securite-velo-trottinette-b01-lite/BLACK" onClick={closeMenu}>B01 Lite</Link>
            </li>
            <li>
              <Link to="/product/casque-intelligent-lumineux-h01" onClick={closeMenu}>H01</Link>
            </li>
            <li>
              <Link to="/articles" onClick={closeMenu}>Articles</Link>
            </li>
            {/* <li className="border-bottom">
              <Link to="/h01" onClick={closeMenu}>H01</Link>
            </li> */}
            <li className="border-bottom">
              <Link to="https://billing.stripe.com/p/login/5kA2aC7yh6qA2mQfYY" onClick={closeMenu} target="_blank">Mon compte</Link>
            </li>
            <li>
              <Link to="/l-histoire-de-baltee-mobility" onClick={closeMenu}>L'histoire</Link>
            </li>
            <li>
              <Link to="/foire-aux-questions" onClick={closeMenu}>F.A.Q</Link>
            </li>
            <li>
              <Link to="/qr/notices-utilisation" onClick={closeMenu}>Notices</Link>
            </li>
            <li>
              <Link to="/contact" onClick={closeMenu}>Contact & SAV</Link>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
}
